exports.onRouteUpdate = ({ prevLocation }) => {
  if (prevLocation && window.pawpThirdPartySnippetLoaded === false) {
    window.pawpThirdPartySnippetLoader()
  }
}
